import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";

// Get all partner services
export const GetPartnerServices = () => {
  const services = useQuery({
    queryKey: ["get-partner-services"],
    queryFn: () => client.partnerServices.getAllServices(),
  });
  return services;
};

// Get single partner service by ID
export const GetSinglePartnerService = (id) => {
  const service = useQuery({
    queryKey: ["get-single-partner-service", id],
    queryFn: () => client.partnerServices.getSingleService(id),
    enabled: !!id,
  });
  return service;
};

// Add new partner service
export const AddPartnerService = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();
  
  const addService = useMutation({
    mutationFn: (data) => client.partnerServices.addService(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Partner service added successfully!", "success");
        queryClient.invalidateQueries(["get-partner-services"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to add partner service!", "error");
    },
  });
  
  return addService;
};

// Update partner service
export const UpdatePartnerService = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();
  
  const updateService = useMutation({
    mutationFn: ({ id, data }) => client.partnerServices.updateService(id, data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Partner service updated successfully!", "success");
        queryClient.invalidateQueries(["get-partner-services"]);
        queryClient.invalidateQueries(["get-single-partner-service"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update partner service!", "error");
    },
  });
  
  return updateService;
};

// Delete partner service
export const DeletePartnerService = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();
  
  const deleteService = useMutation({
    mutationFn: (id) => client.partnerServices.deleteService(id),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Partner service deleted successfully!", "success");
        queryClient.invalidateQueries(["get-partner-services"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to delete partner service!", "error");
    },
  });
  
  return deleteService;
};

// Toggle partner service status
export const TogglePartnerServiceStatus = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();
  
  const toggleStatus = useMutation({
    mutationFn: ({ id, status }) => client.partnerServices.toggleStatus(id, status),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Status updated successfully!", "success");
        queryClient.invalidateQueries(["get-partner-services"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update status!", "error");
    },
  });
  
  return toggleStatus;
};